<template>
  <ValidationProvider name="pipeline template" slim vid="pipeline_template_id">
    <template #default="{ errors }">
      <BaseFormGroup>
        <BaseFormLabel> Pipeline Template </BaseFormLabel>
        <VSelect
          v-model="emailTemplateId"
          :options="options"
          label="name"
          :reduce="(option) => option.id"
          class="vue-select custom-option"
          :filterable="false"
          :searchable="false"
        >
          <template #option="{ name }">
            <span class="block truncate px-3 py-2">{{ name }}</span>
          </template>
          <template v-if="hasMoreOptions" #list-footer>
            <li class="flex space-x-2 mt-2">
              <BaseButton
                primary
                outline
                small
                :disabled="isOptionsFirstPage"
                class="flex-1"
                @click="fetchPrevPage"
              >
                Prev
              </BaseButton>
              <BaseButton
                primary
                outline
                small
                :disabled="isOptionsLastPage"
                class="flex-1"
                @click="fetchNextPage"
              >
                Next
              </BaseButton>
            </li>
          </template>
          <template #no-options>
            <div class="p-4">No pipeline templates found.</div>
          </template>
        </VSelect>
        <BaseFormInlineMessage v-if="errors.length" danger>
          {{ errors[0] }}
        </BaseFormInlineMessage>
      </BaseFormGroup>
    </template>
  </ValidationProvider>
</template>

<script>
import apiFetch from '@/api/clients';

export default {
  props: {
    value: {
      type: String,
      default: null,
    },
    accountId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      options: [{ id: null, name: 'Start from scratch' }],
      meta: {
        current_page: 1,
        last_page: 1,
        per_page: 15,
        total: 0,
      },
    };
  },
  computed: {
    emailTemplateId: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    hasMoreOptions() {
      return this.meta.total > this.meta.per_page;
    },
    isOptionsFirstPage() {
      return this.meta.current_page === 1;
    },
    isOptionsLastPage() {
      return this.meta.last_page === this.meta.current_page;
    },
  },
  created() {
    this.fetchEmailTemplates();
  },
  methods: {
    async fetchEmailTemplates(page = 1) {
      try {
        const response = await apiFetch.get('pipeline-templates', {
          page,
          sort: '-created_at',
        });

        const { data = [], meta = {} } = response.data;
        this.options = [
          { id: null, name: 'Start from scratch' },
          ...(Array.isArray(data) ? data : []),
        ];
        this.meta.current_page = meta?.current_page ?? 1;
        this.meta.last_page = meta?.last_page ?? 1;
        this.meta.per_page = meta?.per_page ?? 15;
        this.meta.total = meta?.total ?? 0;

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    fetchPrevPage() {
      if (this.isOptionsFirstPage) {
        return;
      }

      this.fetchEmailTemplates(this.meta.current_page - 1);
    },
    fetchNextPage() {
      if (this.isOptionsLastPage) {
        return;
      }

      this.fetchEmailTemplates(this.meta.current_page + 1);
    },
  },
};
</script>
